import React, { FC, useState } from 'react';

import { useAppDispatch } from 'store';
import { IContract, IPaginationParams } from 'types';
import { loadContractsAction } from 'store/contracts/contracts.reducer';
import { ContractsList } from './components/ContractsList/ContractsList';
import styles from './Contracts.module.scss';

const ContractsPage: FC = () => {
  const dispatch = useAppDispatch();
  const [error, setError] = useState('');
  const [data, setData] = useState<IContract[]>([]);
  const [pagination, setPagination] = useState({ page: 0, pageSize: 10 });
  const [hasNextPage, setHasNextPage] = useState(true);

  const loadNextPage = async (paginationParams: IPaginationParams) => {
    try {
      const { data } = await dispatch(loadContractsAction(paginationParams));
      setPagination(paginationParams);
      setData(oldData => [...oldData, ...data]);
      setHasNextPage(data.length >= paginationParams.pageSize);

    } catch (e: any) {
      setHasNextPage(false);
      setError(e?.message);
    }
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.title}>Договоры</div>
      {error && <div className={styles.error}>{error || 'Что-то пошло не так'}</div>}
      <div className={styles.list}>
        <ContractsList
          items={data}
          hasNextPage={hasNextPage}
          loadNextPage={loadNextPage}
          pagination={pagination}
        />
      </div>
    </div>
  );
};

export default ContractsPage;
